import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import SearchBars from 'components/SearchBars';
import Card from 'components/Card';
import { observer, inject } from 'mobx-react';
import WorkReportsTable, { COLUMNS, CARDS, MIN_TABLE_WIDTH } from 'components/Tables/WorkReports';
import * as DataList from 'components/DataList';
import styled from '@emotion/styled';

const PageWrapGray = styled('div')`
  padding: 12px;
  background-color: #F8FAFB;
  min-height: calc(100vh - 75px);
`

@inject('store', 'workReportStore', 'viewStore') @observer
class WorkReportsIndexPage extends Component {

  render() {
    let content;
    let {
      workReportStore,
      viewStore,
      workReportStore: {
        workReports: {
          isLoading,
          isError
        }
      }
    } = this.props;
    if (isLoading && !isError) {
      content = (
        <DataList.Loading columns={COLUMNS} cards={CARDS} minTableWidth={MIN_TABLE_WIDTH} noun="work orders" />
      );
    }
    if (isError && !isLoading) {
      content = <DataList.LoadError noun="work orders" onRetry={() => workReportStore.loadWorkReports()} />;
    }
    if (!isError && !isLoading) {
      content = <WorkReportsTable />
    }
    return (
      <div>
        <Helmet>
          <title>Work Orders | FieldNexus</title>
        </Helmet>
        <PageWrapGray>
            <SearchBars.WorkReport key={viewStore.listFiltersVersion} />
          <Card>
            {content}
          </Card>

        </PageWrapGray>
      </div>
    )
  }
};

export default WorkReportsIndexPage;
